module.exports = "/static/bin/firmware.bin";